import { getAuthToken } from "../utils/auth";
import { showErrors } from "../utils/ui";

const tokenIsExpired = (message) => {
  if (message === "Invalid Token") {
    return true;
  }
  return false;
};

const getContentType = (res) => {
  const isJSON =
    res.headers.get("Content-Type")?.startsWith("application/json") || false;
  if (isJSON) {
    return "JSON";
  }

  const isText = res.headers.get("Content-Type")?.startsWith("text") || false;
  if (isText) {
    return "Text";
  }

  return "Unsupported";
};

const processResponse = async (res) => {
  const contentType = getContentType(res);

  if (res.ok) {
    if (contentType === "JSON") {
      return await res.json();
    } else {
      return res;
    }
  }
};

const accessAPI = async (method, url, body) => {
  try {
    let baseUrl = process.env.REACT_APP_BACKEND_URL;
    const token = getAuthToken();
    const isFormdata = body instanceof FormData;
    const headers = {
      Authorization: `Bearer ${token}`,
      app_id: process.env.REACT_APP_NAME,
    };
    if (!isFormdata) {
      headers["Content-Type"] = "application/json";
    }
    const result = await fetch(baseUrl + url, {
      method: method,
      body: isFormdata ? body : JSON.stringify(body),
      headers,
    });
    if (result.ok) {
      return await processResponse(result);
    } else {
      const errorJson = await result.json();
      const errorMessage = errorJson.message;
      if (tokenIsExpired(errorMessage)) {
        showErrors("Session expired", { toastId: "session-expired" });
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 2000)
      }
      if (errorJson.data) {
        throw errorJson;
      }
      const errorToThrow = {
        message: errorJson.message,
        status: errorJson.status || result.status,
      };
      throw errorToThrow;
    }
  } catch (e) {
    throw e;
  }
};

export const get = async (url) => {
  return await accessAPI("GET", url);
};

export const post = async (url, body) => {
  return await accessAPI("POST", url, body);
};

export const put = async (url, body) => {
  return await accessAPI("PUT", url, body);
};

export const del = async (url, body) => {
  return await accessAPI("DELETE", url, body);
};
